import React, { useState, useRef, useEffect } from 'react';
import styles from './pages/Application.module.css';

const ImageGallery = ({ theme = 'light' }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const containerRef = useRef(null);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const images = [
    { src: '/images/1ios.jpg', alt: 'App screenshot 1' },
    { src: '/images/2ios.jpg', alt: 'App screenshot 2' },
    { src: '/images/3ios.jpg', alt: 'App screenshot 3' },
    { src: '/images/4ios.jpg', alt: 'App screenshot 4' },
    { src: '/images/5ios.jpg', alt: 'App screenshot 5' },
  ];

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const swipeThreshold = 50;
    const diff = touchStartX.current - touchEndX.current;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0 && currentIndex < images.length - 1) {
        setCurrentIndex(currentIndex + 1);
      } else if (diff < 0 && currentIndex > 0) {
        setCurrentIndex(currentIndex - 1);
      }
    }
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const sectionStyle = theme === 'dark' ? { background: 'transparent' } : {};

  if (!isMobile) {
    // Desktop: Original grid layout
    return (
      <section className={styles.gallerySection} style={sectionStyle}>
        <div className={styles.galleryContainer}>
          {images.map((image, index) => (
            <img
              key={index}
              src={image.src}
              alt={image.alt}
              className={styles.galleryImage}
            />
          ))}
        </div>
      </section>
    );
  }

  // Mobile: Swipable carousel
  return (
    <section className={styles.gallerySection} style={sectionStyle}>
      <div className={styles.carouselWrapper}>
        <div
          ref={containerRef}
          className={styles.carouselContainer}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div
            className={styles.carouselTrack}
            style={{
              transform: `translateX(-${currentIndex * 100}%)`,
            }}
          >
            {images.map((image, index) => (
              <div key={index} className={styles.carouselSlide}>
                <img
                  src={image.src}
                  alt={image.alt}
                  className={styles.galleryImage}
                />
              </div>
            ))}
          </div>
        </div>

        <div className={styles.carouselDots}>
          {images.map((_, index) => (
            <button
              key={index}
              className={`${styles.dot} ${
                index === currentIndex ? styles.dotActive : ''
              }`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImageGallery;